import React from 'react';
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";

import Moment from 'moment';
import csLocale from "date-fns/locale/cs";
import {DataGrid} from '@mui/x-data-grid';
import Icon from "@mui/material/Icon";
import {Clear, Edit, Delete, Note} from '@mui/icons-material' ;
import {green, grey} from "@mui/material/colors";
import NoteDialog from "./NoteDialog";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFnsV3";
import apiWorker from "./ApiHelper";
import {parse} from "date-fns";

export default class OverViewTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            RootURL: apiWorker.GetRootUrlWithCurrentDomain(),
            ApiURL: apiWorker.GetUrlWithCurrentDomain("wp-json/reservation-plugin/controller"),
            EditURL: apiWorker.GetUrlWithCurrentDomain("rezervace?henry="),
            fetchAction: "GetAllReservations",
            selectedDate: Date.now(),
            actualData: [],
            TableColumns: [
                {headerName: "Celé jméno", field: "FullName",flex: 1},
                {headerName: "Datum narození", field: "birthDay",flex: 1},
                {headerName: "Telefonní číslo", field: "phoneNr",flex: 1},
                {headerName: "Datum objednání", field: "orderedDate",flex: 1},
                {headerName: "Čas objednání", field: "orderedTime",flex: 1},
                //{title: "Poznámka", field: "note"},
                {
                    headerName: "Akce", field: "actionField",flex: 1, renderCell: (params) =>
                        (
                            <div>
                                <IconButton disabled={params.row.note.length <= 1} onClick={() => {
                                    this.OpenDialog(params.row.note, "Poznámka", () => this.setState({open: false}), "Zavřít")
                                }}><Note
                                    style={{color: params.row.note.length > 1 ? green[500] : grey[300]}}/></IconButton>
                                <IconButton onClick={() => {
                                    this.handleEditClick(params.row.id)
                                }}> <Edit/> </IconButton>
                                <IconButton onClick={() => {
                                    this.handleUserDeleteClick(params.row.id)
                                }}><Delete/></IconButton>
                            </div>
                        )
                }
            ],
            open: false
        }
        ;

        this.dialogRef = React.createRef();

        this.download = this.download.bind(this);
        this.handleDate = this.handleDate.bind(this);
        this.handleSearchClick = this.handleSearchClick.bind(this);
        this.handleResetClick = this.handleResetClick.bind(this);
        this.deleteReservation = this.deleteReservation.bind(this);
        this.handleUserDeleteClick = this.handleUserDeleteClick.bind(this);
        this.handleEditClick = this.handleEditClick.bind(this);
    }

    componentDidMount() {
        this.download();
    }

    download(date = null) {
        let formData = new FormData();
        formData.append("action", this.state.fetchAction);
        if (date !== null) {
            formData.append("date", new Moment(this.state.selectedDate).format("DD.MM.YYYY"));
        }
        fetch(this.state.ApiURL, {
            method: "post",
            body: formData
        }).then(response => {
            if (response.ok)
                return response.json();
            return null;
        }).then(data => {
            if (data == null)
                return;
            this.ProcessData(data);
        });
    }

    deleteReservation(userId) {
        let formData = new FormData();
        formData.append("action", "deleteReservation");
        if (userId !== null || userId !== "") {
            formData.append("id", userId);
            fetch(this.state.ApiURL, {
                method: "post",
                body: formData

            }).then(response => {
                if (response.ok)
                    return response.json();
            }).then(data => {
                if (data === "1")
                    this.download();
            });
        }
    }

    OpenDialog(_dialogBody, _dialogTitle, _callback, _dialogBtnAgreeText = "SOUHLASÍM") {
        this.setState({
            dialogTitle: _dialogTitle,
            dialogBody: _dialogBody,
            dialogCallback: _callback
        }, () => {
            this.dialogRef.current.Open(this.state.dialogBody, this.state.dialogTitle, _dialogBtnAgreeText);
        });
    }

    ProcessData(json) {
        let processedData = JSON.parse(json);
        let finalData = processedData.map(data => {
            return {
                id: data.id,
                FullName: data.FullName,
                birthDay: data.birthDay,
                phoneNr: data.phoneNr,
                orderedDate: data.orderedDate, // parse(data.orderedDate,"dd.MM.yyyy",new Date()),
                orderedTime: data.orderedTime,
                note: data.note,
                /*  actionField: <div>
                      <IconButton disabled={data.note.length <= 1} onClick={() => {
                      this.OpenDialog(data.note,"Poznámka",()=>this.setState({open:false}),"Zavřít")
                      }}><Note style={{color: data.note.length > 1 ? green[500] : grey[300] }} /></IconButton>
                      <IconButton  onClick={() => {
                          this.handleEditClick(data.id)
                      }}> <Edit/> </IconButton>
                      <IconButton onClick={() => {
                          this.handleUserDeleteClick(data.id)
                      }}><Delete/></IconButton>
                  </div>*/
            };
        });
        this.setState({actualData: finalData});
    }

    handleEditClick(id) {
        window.location = this.state.EditURL + id;
    }

    handleUserDeleteClick(userId) {
        this.deleteReservation(userId);
    }


    handleDate(date) {
        this.setState({selectedDate: new Moment(date)});
    }

    handleSearchClick() {
        this.download(this.state.selectedDate);
    }

    handleResetClick() {
        this.download();
    }

    render() {
        return (
            <div>
                <NoteDialog ref={this.dialogRef} AgreementCallback={this.state.dialogCallback}/>
                {/*  <MuiPickersUtilsProvider utils={DateFNSUtils} locale={csLocale}>
                    <DatePicker
                        format={'dd.MM.yyyy'}
                        okLabel={"Vybrat"}
                        cancelLabel={"Zrušit výběr"}
                        value={this.state.selectedDate}
                        onChange={(event) => this.handleDate(event)}
                        id={"FilterDate"}
                        label={"Datum rezervace"}
                        margin={"normal"}
                    />
                </MuiPickersUtilsProvider>*/}
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={csLocale}>
                    <DatePicker disablePast={true} format={'dd.MM.yyyy'} okLabel={"Vybrat"}
                                cancelLabel={"Zrušit výběr"}
                                value={this.state.requestDate}
                                onChange={(event) => this.handleDate(event)}
                                label={"Datum rezervace"}
                                id={"FilterDate"}
                    />
                </LocalizationProvider>
                <br/>
                <Button color={"primary"} variant={"contained"} style={{margin: 10}} startIcon={<Icon>send</Icon>}
                        onClick={this.handleSearchClick}>Vyhledat pro datum</Button>
                <Button color={"secondary"} variant={"contained"} startIcon={<Clear/>}
                        onClick={this.handleResetClick}>Vyhledat vše</Button>

                <DataGrid columns={this.state.TableColumns} rows={this.state.actualData}
                          title={"Objednaní pacienti"} options={{search: true, sorting: true}}/>
            </div>

        );
    }


}
